import { PaperCardTemplate } from 'components/templates/PaperCardTemplate';
import { FC } from 'react';
import { IReportList } from 'types/Report';

import InfoIcon from '@mui/icons-material/Info';
import {
  Grid,
  styled,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  tooltipClasses,
  TooltipProps,
  Zoom,
} from '@mui/material';

export interface IReportListProps extends IReportList {
  loading: boolean;
}

const StyledTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.primary.main,
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.primary.main,
  },
}));

export const ReportList: FC<IReportListProps> = ({ loading, list }) => {
  return (
    <PaperCardTemplate loading={loading}>
      <TableContainer>
        <Table size="small" aria-label="a dense table" padding="none">
          <TableHead>
            <TableRow>
              <TableCell sx={{ paddingBottom: 6 }} />
              {list?.map((date) => (
                <TableCell key={date.month} align="center" sx={{ paddingX: 1 }}>
                  {date.month}/{date.year}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>

          <TableBody>
            <TableRow>
              <TableCell colSpan={1} sx={{ paddingY: 2, paddingLeft: 2 }}>
                <Grid container spacing={1}>
                  <Grid item alignSelf="center">
                    Vínculo empregatício ativo
                  </Grid>
                  <Grid item>
                    <StyledTooltip
                      arrow
                      placement="right"
                      title="Quantidade total de colaboradores da empresa."
                      TransitionComponent={Zoom}
                      color="#FBB45F"
                    >
                      <InfoIcon
                        cursor="pointer"
                        sx={{
                          color: '#FBB45F',
                          verticalAlign: 'top',
                          fontSize: 18,
                        }}
                      />
                    </StyledTooltip>
                  </Grid>
                </Grid>
              </TableCell>
              {list?.map((data) => (
                <TableCell align="center">
                  {data.totalMembers > 0 ? data.totalMembers : '-'}
                </TableCell>
              ))}
            </TableRow>
            <TableRow style={{ backgroundColor: '#FAFAFA' }}>
              <TableCell colSpan={1} sx={{ paddingY: 2, paddingLeft: 2 }}>
                <Grid container spacing={1}>
                  <Grid item alignSelf="center">
                    Benefício ativo
                  </Grid>
                  <Grid item>
                    <StyledTooltip
                      arrow
                      placement="right"
                      title="Quantidade de colaboradores que estão usufruindo do benefício."
                      TransitionComponent={Zoom}
                      color="#FBB45F"
                    >
                      <InfoIcon
                        cursor="pointer"
                        sx={{
                          color: '#FBB45F',
                          verticalAlign: 'top',
                          fontSize: 18,
                        }}
                      />
                    </StyledTooltip>
                  </Grid>
                </Grid>
              </TableCell>
              {list?.map((data) => (
                <TableCell align="center">
                  {data.activeMembers > 0 ? data.activeMembers : '-'}
                </TableCell>
              ))}
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </PaperCardTemplate>
  );
};

